
class HelpModalController {
    constructor($uibModalInstance, type) {
        this.type = type;
        this._$uibModalInstance = $uibModalInstance;

    }

    cancel() {
        this._$uibModalInstance.close();
    }

    next() {

    }
}

HelpModalController.$inject = ['$uibModalInstance', 'type'];

export default HelpModalController;



// WEBPACK FOOTER //
// ./client/app/common/info-widget/help-modal.controller.js